<script lang="ts">
    import { onMount } from 'svelte';
    import TextInput from './InputTypes/TextInput.svelte';
    import BirthdayInput from './InputTypes/BirthdayInput.svelte';
    import DropdownInput from './InputTypes/DropdownInput/DropdownInput.svelte';
    import DatePickerInput from './InputTypes/DatePickerInput/DatePickerInput.svelte';
    import PhoneInput from './InputTypes/PhoneInput.svelte';
    import TextareaInput from './InputTypes/TextareaInput.svelte';
    import FileInput from './InputTypes/FileInput.svelte';
    import CheckboxInput from './InputTypes/CheckboxInput.svelte';

    // Types
    import type { ComponentType } from 'svelte';
    import type { RawDraftContentState } from 'draft-js';
    import type { Language } from '$lib/types/Language';
    import type { CustomOptions } from '$lib/types/Components/FormQuestion/CustomOptions';
    import { PhoneValidationKind } from '$lib/types/PhoneValidationKind';

    // Final Form
    export let finalFormInput = {};

    // Text
    export let name = '';
    export let type = '';
    export let placeholder = '';
    export let emoji = '';
    export let showEmoji = true;
    export let conversionTrigger = false;
    export let customOptions: Partial<CustomOptions> = {};
    export let required = false;
    export let pristine = false;
    export let touched = false;
    export let active = false;

    // File
    export let onFileAccept: (file: File) => void = () => null;
    export let uploading = false;

    // Checkbox
    export let wysiwyg: RawDraftContentState | undefined = undefined;

    // Validation
    export let invalid = false;
    export let errorMessage = '';

    // Styling
    export let isFirst = false;
    export let isLast = false;

    // Localisation
    export let language: Language = 'de';

    let Input: ComponentType;

    onMount(async () => {
        switch (type) {
            case 'text':
                Input = TextInput;
                break;
            case 'email':
                Input = TextInput;
                break;
            case 'url':
                Input = TextInput;
                break;
            case 'number':
                Input = TextInput;
                break;
            case 'birthday':
                Input = BirthdayInput;
                break;
            case 'dropdown':
                Input = DropdownInput;
                break;
            case 'datePicker':
                Input = DatePickerInput;
                break;
            case 'phone':
                if (
                    type === 'phone' &&
                    customOptions?.phoneValidationKind === PhoneValidationKind.CountryFormat
                ) {
                    Input = PhoneInput;
                } else {
                    Input = TextInput;
                }
                break;
            case 'textarea':
                Input = TextareaInput;
                break;
            case 'file':
                Input = FileInput;
                break;
            case 'checkbox':
                Input = CheckboxInput;
                break;
        }
    });
</script>

<svelte:component
    this={Input}
    {name}
    {type}
    {placeholder}
    {emoji}
    {showEmoji}
    {invalid}
    {active}
    {pristine}
    {required}
    {isFirst}
    {isLast}
    {touched}
    {wysiwyg}
    {conversionTrigger}
    {customOptions}
    {finalFormInput}
    {onFileAccept}
    {uploading}
    {errorMessage}
    {language}
/>
